import checkboxOn from '../../images/svg/checkbox_on.svg';
import checkboxOff from '../../images/svg/checkbox_off.svg';
const {aoflValidate, apiInputErrorHandler, isRequired, isValidEmail, AppCallService} = aofljs;
const {abcmouseApiService, AoflElement, store, clickTrackerMixin, abcmouseTrackerQueue, PixelService} = aofljs;
/**
 * @summary WiaProspectRegForm
 * @class WiaProspectRegForm
 * @extends {clickTrackerMixin(aoflValidate(AoflElement))}
 */
class WiaProspectRegForm extends clickTrackerMixin(aoflValidate(AoflElement)) {
  /**
   * Creates an instance of WiaProspectRegForm.
   * @memberof WiaProspectRegForm
   */
  constructor() {
    super(store);
    this.checkboxOn = checkboxOn;
    this.checkboxOff = checkboxOff;
    this.unsubscribeStore = store.subscribe(() => this.mapProperties());
    this.mapProperties();
    this.validators = this.defineValidators();
  }

  /**
   * Defines the name of this component.
   *
   * @readonly
   * @static
   * @memberof WiaProspectRegForm
   */
  static get is() {
    return 'wia-prospect-reg-form';
  }

  /**
   *
   *
   * @memberof WiaProspectRegForm
   */
  connectedCallback() {
    super.connectedCallback();
    // setTimeout to work around for Firefox polyfill
    setTimeout(() => {
      this.$.email.focus();
    }, 0);
  }

  /**
   * Maps component properties to state.
   *
   * @memberof WiaProspectRegForm
   */
  mapProperties() {
    // let state = store.getState().prospectRegForm;
    let state = store.getState();
    this.checked = state.abcmouseCheckbox.prospectRegForm.checked;
    this.email = state.prospectRegForm.email;
    this.apiErrors = state.prospectRegForm.apiErrors;
    this.showForm = !state.prospectRegForm.elog;
  }

  /**
   * Defines validators for each component property.
   *
   * @return {Object} The validation state object
   * @memberof WiaProspectRegForm
   */
  defineValidators() {
    return {
      email: {isRequired, isValidEmail},
      checked: {isRequired},
      apiErrors: {
        isValidEmail: apiInputErrorHandler('email', 'syntax', 'invalid_email_syntax')
      }
    };
  }

  /**
   *
   * @param {Object} e The standard event object
   * @memberof WiaProspectRegForm
   */
  submitForm(e) {
    e.preventDefault();
    // Validates the form. Resets apiErrors before validating
    store.commit([
      {
        stateAlias: 'prospectRegForm',
        mutationId: 'updateApiErrors',
        payload: null
      }
    ]);
    this.$v.$touch();
    if (!this.$v.$valid) return;

    let payload = {
      email: this.email,
      eventData: {
          source: 'mini reg:thank you for watching our video pop'
      }
    };

    abcmouseApiService.prospectReg(payload)
      .then((resp) => {
        this._makeAdjustLogEventAppCall(resp);
        const pixels = (resp.pixel.pixel_value && resp.pixel.pixel_type === 'client-side') ? resp.pixel.pixel_value : '';
        PixelService.fire(pixels, 'prospect-reg')
        .then((resp) => {
          // Redirect to subscription if no errors
         window.location = '/abt/subscription';
        }).catch((err) => {
          abcmouseTrackerQueue.enqueueEvent({
            url: '@pixelFire:failed'
          });
        });
      })
      .catch((err) => {
        store.commit([
          {
            stateAlias: 'prospectRegForm',
            mutationId: 'updateApiErrors',
            payload: err
          }
        ]);
        this.$v.apiErrors.$touch();
      });
  }

  /**
   *
   * @param {Object} e The standard event object
   * @memberof WiaProspectRegForm
   */
  updateEmail(e) {
    let email = e.target.value;
    store.commit([
      {
        stateAlias: 'prospectRegForm',
        mutationId: 'updateEmail',
        payload: email
      }
    ]);
  }

  /**
   *
   * @param {Object} e The standard event object
   * @memberof WiaProspectRegForm
   */
  toggleChecked(e) {
    let checked = !this.checked;
    let checkedTrackingString = checked ? 'check' : 'uncheck';
    let payload = {
      prospectRegForm: {
        checked,
        dirty: true,
        checkedValue: null
      }
    };

    store.commit([
      {
        stateAlias: 'abcmouseCheckbox',
        mutationId: 'toggleChecked',
        payload
      }
    ]);

    abcmouseTrackerQueue.enqueueEvent({
      url: '@linkClick',
      kvp: {
        linkName: `non-member homepage:thank you for watching our video pop:agree to emails: ${checkedTrackingString}`
      }
    });
  }

  /**
   *
   * @param {Object} e The standard event object
   * @memberof WiaProspectRegForm
   */
  redirect(e) {
    window.location = '/abt/subscription';
  }

  /**
   *
   * Makes the Adjust tracking app call
   * @param {Object} payload the payload returned form the API
   * @memberof WiaProspectRegForm
   */
  _makeAdjustLogEventAppCall(payload) {
    let eventToken = payload.logAdjustEvent.token;
    let customParameters = payload.logAdjustEvent.customParameters;
    AppCallService.logAdjustEvent(eventToken, customParameters);
  }

  /**
   *
   * @memberof WiaProspectRegForm
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    this.unsubscribeStore();
  }
}

window.customElements.define(WiaProspectRegForm.is, WiaProspectRegForm);



// WEBPACK FOOTER //
// ./home/en-US/js/wia-prospect-reg-form/wia-prospect-reg-form.js